StickySidebar.prototype.forceUpdate = function() {
  this._reStyle = true;
  this.direction = 'down';
  this.updateSticky()
}

StickySidebar.prototype.isSidebarFitsViewport = function() {
  var topSpacing = this.options.topSpacing;
  var bottomSpacing = this.options.bottomSpacing;
  if( 'function' === typeof topSpacing )
    topSpacing = parseInt(topSpacing(this.sidebar)) || 0;

  if( 'function' === typeof bottomSpacing )
    bottomSpacing = parseInt(bottomSpacing(this.sidebar)) || 0;

  return this.dimensions.sidebarHeight + topSpacing + bottomSpacing < this.dimensions.viewportHeight;
}

if(!customElements.get('sticky-sidebar')) {
  class Sidebar extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.titles = this.querySelectorAll('.sidebar__nav-outer__item__title')
      this.inners = this.querySelectorAll('.sidebar__nav-inner')
      this.titles.forEach((title) => {
        title.addEventListener('click', this.handleTitleClick.bind(this))
      })
    }

    handleTitleClick(evt) {
      if(evt.target.nextElementSibling.classList.contains('open')) {
        evt.target.nextElementSibling.classList.remove('open')
      } else {
        this.closeAllInners()
        evt.target.nextElementSibling.classList.add('open')
      }
    }

    closeAllInners() {
      this.inners.forEach((inner) => {
        inner.classList.remove('open')
      })
    }

  }
  customElements.define('sticky-sidebar', Sidebar);
}
